import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { AgentType } from 'owa-bizchat-types';

/**
 * Returns the default Calendar agent type based on active flights,
 * or undefined when the default calendar agent feature is disabled.
 *
 * This is the single control point for all calendar agent flight gating:
 * - cal-copilot-default-calendar-agent: enables the default calendar agent (legacy TimeAdvisor)
 * - cal-copilot-default-calendar-agent-helix: switches to CalendarAgentHelix BuiltInAgent
 *
 * Callers should not check these flights individually.
 */
export function getDefaultCalendarAgentType(): AgentType | undefined {
    if (!isGlobalFeatureEnabled('cal-copilot-default-calendar-agent')) {
        return undefined;
    }
    return isGlobalFeatureEnabled('cal-copilot-default-calendar-agent-helix')
        ? 'CalendarAgentHelix'
        : 'TimeAdvisor';
}
